import type { ThreeElements } from '@react-three/fiber'
import { anguloComPreparo, poseFerramentaHidraulica, type FerramentaHidraulicaAnimada } from './animacaoFerramenta'
import { CortadorHolmatro3D } from './CortadorHolmatro3D'
import { CilindroTelescopicoHolmatro3D } from './CilindroTelescopicoHolmatro3D'
import { AlargadorHolmatro3D } from './AlargadorHolmatro3D'

interface Props extends Omit<ThreeElements['group'], 'children'> {
  ferramenta: FerramentaHidraulicaAnimada
  progresso: number
  ativa?: boolean
  modoAlargador?: 'abrir' | 'fechar'
  anguloMandibula?: number
  /** 0 = garras no estado inicial (no ar), 1 = pose de trabalho. */
  preparo?: number
  estadoInicial?: 'aberto' | 'fechado' | null
}

/**
 * Maquete articulada da ferramenta hidráulica. A posição e a orientação pertencem à
 * cena; `progresso` controla o movimento visual dos componentes do equipamento.
 */
export function FerramentaHidraulica3D({
  ferramenta,
  progresso,
  ativa = false,
  modoAlargador = 'abrir',
  anguloMandibula,
  preparo = 1,
  estadoInicial,
  ...groupProps
}: Props) {
  const pose = poseFerramentaHidraulica(ferramenta, progresso, modoAlargador)
  const angulo = anguloComPreparo(ferramenta, anguloMandibula ?? pose.anguloMandibula, preparo, estadoInicial)

  if (ferramenta === 'cortadorHidraulico') {
    return (
      <group {...groupProps}>
        <CortadorHolmatro3D anguloMandibula={angulo} ativa={ativa} />
      </group>
    )
  }

  if (ferramenta === 'extensor') {
    return (
      <group {...groupProps}>
        <CilindroTelescopicoHolmatro3D
          curso={pose.cursoExtensor}
          progresso={progresso}
          ativa={ativa}
        />
      </group>
    )
  }

  if (ferramenta === 'alargador') {
    return (
      <group {...groupProps}>
        <AlargadorHolmatro3D
          anguloMandibula={angulo}
          ativa={ativa}
        />
      </group>
    )
  }

  return null
}

